import { Flex } from '@chakra-ui/react';
import { useSearchParams } from 'react-router-dom';

import { LotVariant, useOpenLots } from '../api/lot';
import { PageHeader } from '../widgets/PageHeader';
import { SegmentedControls } from '../widgets/SegmentedControls';
import { AsOfDateTag } from '../widgets/Table/AsOfDateTag';
import { ClosedLotList } from './ClosedLotTable';
import { OpenLotList } from './OpenLotTable';

export const LotList = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const dataVariant = (searchParams.get('dataVariant') || 'open') as LotVariant;

    const { data: openLotsPage } = useOpenLots({ pagination: { pageSize: 1, pageIndex: 0 } });

    return (
        <>
            <PageHeader title="Lots">
                <Flex flex={1} justifyContent="space-between" alignItems="center">
                    <SegmentedControls
                        onClick={(value) =>
                            setSearchParams((params) => {
                                params.set('dataVariant', value);
                                return params;
                            })
                        }
                        selectedValue={dataVariant}
                        options={[
                            { value: 'open', label: 'Open' },
                            { value: 'closed', label: 'Closed' },
                        ]}
                    />
                    {dataVariant === 'open' && <AsOfDateTag dateString={openLotsPage?.asOfDate} />}
                </Flex>
            </PageHeader>
            {dataVariant === 'open' ? <OpenLotList /> : <ClosedLotList />}
        </>
    );
};
